// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3ZsWd","messages":"Chat_messages__z3jOw","dateDivider":"Chat_dateDivider__xpSSs"};